import { ScreenName, SURFACE_TO_SCREEN_MAP } from '../../types/screen-names';
import eventQueue from '../queue';
import { EventSurface } from '../../types/events';
function attachEventListener() {
    // HACK: Currently, `impression` events are emitted *at least once* per surface, rather than
    // exactly once (e.g., we fire a new impression tracking event whenever the user types on a
    // search results screen). Since we only want each `screen_transition` client event to fire
    // once per screen, we must check if we're firing a duplicate event by checking against the
    // previous event's screen. In the future, we may want to refactor our logging so that we have
    // a separate event type for the initial screen impression.
    var lastEventScreenName = null;
    eventQueue.on('impression', function (_a) {
        var _b, _c, _d, _e, _f, _g;
        var state = _a.state, fireClientEvent = _a.fireClientEvent;
        var currentSurface = state.segment.currentSource;
        // HACK: there is a minor edge case where `lastEventScreenName` does not reset to null
        // when the Link modal is closed and re-opened (as the iframe is not re-created), causing
        // the event to not fire on re-open if the user was previously on the same screen prior
        // to exiting. In this case, we should fire the event again because technically speaking,
        // the user is transitioning to a new screen when the modal is re-opened.
        if (currentSurface === EventSurface.MODAL_INITIALIZATION) {
            lastEventScreenName = null;
        }
        var screenName = SURFACE_TO_SCREEN_MAP[currentSurface];
        if (screenName != null && screenName !== lastEventScreenName) {
            var payload = { screenName: screenName };
            var providerEntity = state === null || state === void 0 ? void 0 : state.providerEntity;
            var loadedPlatform = (_b = state === null || state === void 0 ? void 0 : state.linkApi.context) === null || _b === void 0 ? void 0 : _b.platform;
            var loadedEmployer = (_c = state === null || state === void 0 ? void 0 : state.linkApi.context) === null || _c === void 0 ? void 0 : _c.employer;
            var selectedEmployerId = loadedEmployer
                ? loadedEmployer.id
                : (_d = providerEntity === null || providerEntity === void 0 ? void 0 : providerEntity.selectedEmployer) === null || _d === void 0 ? void 0 : _d.id;
            var selectedEmployerName = loadedEmployer
                ? loadedEmployer.name
                : (_e = providerEntity === null || providerEntity === void 0 ? void 0 : providerEntity.selectedEmployer) === null || _e === void 0 ? void 0 : _e.name;
            var selectedPlatformId = loadedPlatform
                ? loadedPlatform.id
                : (_f = providerEntity === null || providerEntity === void 0 ? void 0 : providerEntity.selectedPlatform) === null || _f === void 0 ? void 0 : _f.id;
            var selectedPlatformName = loadedPlatform
                ? loadedPlatform.name
                : (_g = providerEntity === null || providerEntity === void 0 ? void 0 : providerEntity.selectedPlatform) === null || _g === void 0 ? void 0 : _g.name;
            // Product ask to include platform/employer info into the payload on LOGIN
            if (screenName === ScreenName.LOGIN) {
                payload.selectedEmployerId = selectedEmployerId;
                payload.selectedEmployerName = selectedEmployerName;
                payload.selectedPlatformId = selectedPlatformId;
                payload.selectedPlatformName = selectedPlatformName;
            }
            var otherEventPayload = Object.entries(payload).map(function (_a) {
                var key = _a[0], value = _a[1];
                return ({
                    key: key,
                    value: value !== null && value !== void 0 ? value : 'null',
                    type: 'string',
                });
            });
            otherEventPayload.push({
                key: 'previousScreenName',
                value: lastEventScreenName !== null && lastEventScreenName !== void 0 ? lastEventScreenName : 'null',
                type: 'string',
            });
            fireClientEvent('other_event', {
                name: 'screen_transition_expanded',
                payload: otherEventPayload,
            });
            fireClientEvent('screen_transition', payload);
            lastEventScreenName = screenName;
        }
    });
}
attachEventListener();
